/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiCompanyDtoPublicSiteMenuItemDto } from './WebApiCompanyDtoPublicSiteMenuItemDto';
import {
    WebApiCompanyDtoPublicSiteMenuItemDtoFromJSON,
    WebApiCompanyDtoPublicSiteMenuItemDtoFromJSONTyped,
    WebApiCompanyDtoPublicSiteMenuItemDtoToJSON,
} from './WebApiCompanyDtoPublicSiteMenuItemDto';

/**
 * 
 * @export
 * @interface WebApiCompanyDtoCompanyPublicSiteDto
 */
export interface WebApiCompanyDtoCompanyPublicSiteDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiCompanyDtoCompanyPublicSiteDto
     */
    siteTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiCompanyDtoCompanyPublicSiteDto
     */
    siteUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiCompanyDtoCompanyPublicSiteDto
     */
    siteDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiCompanyDtoCompanyPublicSiteDto
     */
    siteLogoPath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiCompanyDtoCompanyPublicSiteDto
     */
    memberTerms?: string | null;
    /**
     * 
     * @type {Array<WebApiCompanyDtoPublicSiteMenuItemDto>}
     * @memberof WebApiCompanyDtoCompanyPublicSiteDto
     */
    menuItems?: Array<WebApiCompanyDtoPublicSiteMenuItemDto> | null;
}

/**
 * Check if a given object implements the WebApiCompanyDtoCompanyPublicSiteDto interface.
 */
export function instanceOfWebApiCompanyDtoCompanyPublicSiteDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCompanyDtoCompanyPublicSiteDtoFromJSON(json: any): WebApiCompanyDtoCompanyPublicSiteDto {
    return WebApiCompanyDtoCompanyPublicSiteDtoFromJSONTyped(json, false);
}

export function WebApiCompanyDtoCompanyPublicSiteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCompanyDtoCompanyPublicSiteDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'siteTitle': !exists(json, 'siteTitle') ? undefined : json['siteTitle'],
        'siteUrl': !exists(json, 'siteUrl') ? undefined : json['siteUrl'],
        'siteDescription': !exists(json, 'siteDescription') ? undefined : json['siteDescription'],
        'siteLogoPath': !exists(json, 'siteLogoPath') ? undefined : json['siteLogoPath'],
        'memberTerms': !exists(json, 'memberTerms') ? undefined : json['memberTerms'],
        'menuItems': !exists(json, 'menuItems') ? undefined : (json['menuItems'] === null ? null : (json['menuItems'] as Array<any>).map(WebApiCompanyDtoPublicSiteMenuItemDtoFromJSON)),
    };
}

export function WebApiCompanyDtoCompanyPublicSiteDtoToJSON(value?: WebApiCompanyDtoCompanyPublicSiteDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'siteTitle': value.siteTitle,
        'siteUrl': value.siteUrl,
        'siteDescription': value.siteDescription,
        'siteLogoPath': value.siteLogoPath,
        'memberTerms': value.memberTerms,
        'menuItems': value.menuItems === undefined ? undefined : (value.menuItems === null ? null : (value.menuItems as Array<any>).map(WebApiCompanyDtoPublicSiteMenuItemDtoToJSON)),
    };
}

